<template lang="">
  <div class="app-toast is--inline">
    <div class="app-toast__text">
      <p class="app-toast__title">Unused Version Detected</p>
      <p>This Driver has versions that are not in use. Select Clean Up Versions to review and delete them.</p>
    </div>
    <div class="app-toast__buttons">
        <a :href="`/admin/drivers/${driver.id}/cleanup`" class="element-button--text element-button is--alt">Clean Up Versions</a>
    </div>
  </div>
</template> 
<script>
export default {
  name: 'DriverDashboardCleanupNotification',
  props: {
    driver: {
      type: Object,
      required: true
    }
  }
}
</script>
